// GameMaster Constants

// Contest IDs
export const GLOW_GAME_CONTEST_ID = 0;

// Contest Names
export const GLOW_GAME_NAME = "Glow Game";
export const NONE_SELECTED = "None Selected";

// Cache Duration
export const CACHE_DURATION_MS = 10000; // 10 seconds

// Quest Tool Names
export const TOOL_NAMES = {
	MAP_EDITOR: "mapEditor",
};

// Quest Status
export const QUEST_STATUS = {
	ACTIVE: "Active",
};

// Event Types
export const EVENT_TYPES = {
	ANNOUNCEMENT: "announcement",
	CHALLENGE: "challenge",
	PRIZE: "prize",
};

// Event Statuses
export const EVENT_STATUS = {
	COMPLETED: "completed",
	ACTIVE: "active",
	UPCOMING: "upcoming",
	SKIPPED: "skipped",
};

// Visibility Types
export const VISIBILITY = {
	PUBLIC: "public",
	GAMEMASTER: "gamemaster",
};
